import React from 'react';
import { Typography, Card, Divider } from 'antd';
import { FileTextOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

const { Title, Paragraph, Text } = Typography;

const TermsPage = () => {
  return (
    <div style={{ maxWidth: 900, margin: '0 auto', padding: '24px' }}>
      <Card>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <FileTextOutlined style={{ fontSize: 48, color: '#1890ff' }} />
          <Title level={2} style={{ marginTop: 16 }}>
            Όροι Χρήσης και Παροχής Υπηρεσιών
          </Title>
          <Text type="secondary">Τελευταία ενημέρωση: 30/04/2026</Text>
        </div>

        <Title level={4}>ΕΙΣΑΓΩΓΗ</Title>
        <Paragraph>
          Η ιστοσελίδα animap.gr και η σχετική διαδικτυακή πλατφόρμα της animap (εφεξής συνολικά η «ιστοσελίδα» ή ο «ιστότοπος») δημιουργήθηκε και τελεί υπό τη διαχείριση της εταιρείας «Monovia Ι.Κ.Ε.», με αρ. ΓΕΜΗ: 186347801000 και ΑΦΜ: 802964751, η οποία εδρεύει στην Αθήνα, οδός Δώρου αρ. 2, 10431 (εφεξής η «animap», «εμείς» «εμάς», «μας») και συνιστά μια διαδικτυακή πλατφόρμα αφιερωμένη στα ζώα, μέσω της οποίας οι χρήστες της έχουν τη δυνατότητα να αναζητήσουν και να επιλέξουν τον επαγγελματία που ταιριάζει καλύτερα στις ανάγκες τους, να κλείσουν ραντεβού μαζί του, καθώς και να πραγματοποιήσουν παραγγελίες προϊόντων από συνεργαζόμενα pet-shops και συναφή καταστήματα.
        </Paragraph>
        <Paragraph>
          Το παρόν κείμενο (εφεξής οι «Όροι Χρήσης») συνιστά μια δεσμευτική συμφωνία η οποία περιλαμβάνει όλους τους όρους και προϋποθέσεις που διέπουν τις σχέσεις ανάμεσα στην animap και σε εσάς (εφεξής ο «Χρήστης», «εσείς», «εσάς», «σας») αναφορικά με την περιήγησή σας στον ιστότοπο και την εκ μέρους σας χρήση των παρεχόμενων υπηρεσιών.
        </Paragraph>
        <Paragraph>
          Παρακαλούμε διαβάστε προσεκτικά τους παρόντες Όρους Χρήσης καθώς και τη <Link to="/privacy">Δήλωση Προστασίας Προσωπικών Δεδομένων</Link>, πριν ξεκινήσετε να χρησιμοποιείτε τον ιστότοπο. Η εγγραφή σας στην ιστοσελίδα μας και η χρήση των υπηρεσιών της συνεπάγεται την εκ μέρους σας ανεπιφύλακτη αποδοχή των παρόντων Όρων Χρήσης και της Δήλωσης Προστασίας Προσωπικών Δεδομένων του ιστοτόπου, όπως κάθε φορά ισχύουν.
        </Paragraph>

        <Divider />

        <Title level={4}>ΑΝΗΛΙΚΟΙ</Title>
        <Paragraph>
          Η χρήση της ιστοσελίδας και των υπηρεσιών μας επιτρέπεται αποκλειστικά σε Χρήστες που έχουν κλείσει το 18ο έτος της ηλικίας τους. Με την αποδοχή των Όρων Χρήσης ο Χρήστης δηλώνει ότι είναι ενήλικος, άνω των 18 ετών ή, εάν είναι κάτω των 18 ετών, ότι έχει λάβει την απαραίτητη συναίνεση από όλους τους έχοντες τη γονική μέριμνα αυτού και ότι θα παράσχει τα στοιχεία αυτών, εφόσον του ζητηθεί κάτι τέτοιο.
        </Paragraph>

        <Divider />

        <Title level={4}>ΕΓΓΡΑΦΗ ΧΡΗΣΤΗ</Title>
        <Paragraph>
          Οι Χρήστες που επιθυμούν να έχουν πρόσβαση στις υπηρεσίες της animap θα πρέπει να δημιουργήσουν το λογαριασμό τους στην ιστοσελίδα, συμπληρώνοντας κάποια απαραίτητα στοιχεία που θα τους ζητηθούν για την ταυτοποίησή τους. Η εγγραφή του Χρήστη στην ιστοσελίδα και η χρήση των παρεχόμενων υπηρεσιών πραγματοποιείται καταρχήν δωρεάν, για το βασικό πακέτο υπηρεσιών της animap.
        </Paragraph>
        <Paragraph>
          Ο Χρήστης επιβαρύνεται μόνο με το αντίτιμο που έχει ορίσει ο εκάστοτε επαγγελματίας που επιλέγει για την παροχή των υπηρεσιών του, ή το αντίτιμο για τα προϊόντα που ο Χρήστης παραγγέλνει μέσω του ιστοτόπου.
        </Paragraph>

        <Divider />

        <Title level={4}>ΥΠΗΡΕΣΙΕΣ</Title>
        <Paragraph>
          Η ιστοσελίδα συνιστά ένα διαδικτυακό χώρο αναζήτησης και εξεύρεσης επιχειρήσεων και επαγγελματιών (marketplace), παρέχοντας επίσης τη δυνατότητα κλεισίματος ραντεβού, με εύκολο και άμεσο τρόπο. Η animap παρέχει απλώς την τεχνολογική υποδομή για τη διασύνδεση των Χρηστών με τους προβαλλόμενους επαγγελματίες και επιχειρήσεις.
        </Paragraph>
        <Paragraph>
          Μέσω της ιστοσελίδας ο Χρήστης έχει πρόσβαση σε διάφορες ειδικότητες επαγγελματιών και επιχειρήσεων που σχετίζονται με τη φροντίδα, την υγεία και την ευεξία των ζώων, όπως ενδεικτικά: Κτηνίατροι/Κλινικές ζώων, Εκπαιδευτές, Pet sitters/Pet walkers, Διατροφολόγοι ζώων, Ψυχολόγοι κατοικιδίων.
        </Paragraph>

        <Divider />

        <Title level={4}>ΡΑΝΤΕΒΟΥ ΚΑΙ ΑΚΥΡΩΣΕΙΣ</Title>
        <Paragraph>
          Μέσω της ιστοσελίδας, οι Χρήστες έχουν τη δυνατότητα να δουν τη διαθεσιμότητα του επαγγελματία της επιλογής τους και να κλείσουν ραντεβού για φυσική συνάντηση μαζί του.
        </Paragraph>
        <Paragraph>
          Οι Χρήστες έχουν τη δυνατότητα να αναβάλουν ή να ακυρώσουν ένα επιβεβαιωμένο ραντεβού έως και είκοσι τέσσερις (24) ώρες πριν την συμφωνηθείσα ώρα του ραντεβού, αποκλειστικά μέσω της ιστοσελίδας. Σε περίπτωση έγκαιρης ακύρωσης, η επιστροφή των χρημάτων θα ολοκληρώνεται το αργότερο εντός δέκα (10) εργάσιμων ημερών.
        </Paragraph>

        <Divider />

        <Title level={4}>ΠΑΡΑΓΓΕΛΙΕΣ, ΠΑΡΑΔΟΣΕΙΣ ΚΑΙ ΕΠΙΣΤΡΟΦΕΣ ΠΡΟΪΟΝΤΩΝ</Title>
        <Paragraph>
          Εφόσον εντοπίσει τα προϊόντα που επιθυμεί να αγοράσει και προσδιορίσει την ποσότητά τους, ο Χρήστης υποβάλει την παραγγελία του και πληρώνει το σχετικό αντίτιμο απευθείας μέσω του ιστοτόπου. Όλες οι πληρωμές πραγματοποιούνται με τη χρήση πιστωτικής/χρεωστικής κάρτας μέσω Stripe.
        </Paragraph>
        <Paragraph>
          Ο Χρήστης διατηρεί το δικαίωμα υπαναχώρησης και επιστροφής προϊόντος εντός αποκλειστικής προθεσμίας δεκατεσσάρων (14) ημερών από την ημερομηνία παραλαβής του.
        </Paragraph>

        <Divider />

        <Title level={4}>ΔΙΑΝΟΗΤΙΚΗ ΙΔΙΟΚΤΗΣΙΑ</Title>
        <Paragraph>
          Το "animap" συνιστά κατοχυρωμένο εμπορικό μας σήμα (αρ. κατάθεσης ΟΒΙ N298224). Όλο το περιεχόμενο της ιστοσελίδας αποτελεί πνευματική ιδιοκτησία της animap και προστατεύεται από τις σχετικές διατάξεις του ελληνικού και ευρωπαϊκού δικαίου.
        </Paragraph>

        <Divider />

        <Title level={4}>ΕΦΑΡΜΟΣΤΕΟ ΔΙΚΑΙΟ ΚΑΙ ΔΙΚΑΙΟΔΟΣΙΑ</Title>
        <Paragraph>
          Οι παρόντες Όροι Χρήσης διέπονται και ερμηνεύονται σύμφωνα με τους νόμους της Ελλάδας. Κατά τόπον αρμόδια δικαστήρια για την επίλυση οποιασδήποτε διαφοράς ορίζονται τα καθ' ύλην αρμόδια Δικαστήρια Αθηνών.
        </Paragraph>
        <Paragraph>
          Ως καταναλωτές έχετε το δικαίωμα εξωδικαστικής επίλυσης διαφορών σύμφωνα με τον Κανονισμό (ΕΕ) 524/2013. Για περισσότερες πληροφορίες: <a href="https://consumer-redress.ec.europa.eu/index_el" target="_blank" rel="noopener noreferrer">https://consumer-redress.ec.europa.eu</a>
        </Paragraph>

        <Divider />

        <Title level={4}>ΕΠΙΚΟΙΝΩΝΙΑ</Title>
        <Paragraph>
          Για κάθε απορία ή διευκρίνιση σχετική με τους παρόντες Όρους Χρήσης ή γενικά την ιστοσελίδα και τις παρεχόμενες υπηρεσίες, καθώς και για οποιαδήποτε καταγγελία σχετικά με το περιεχόμενο του ιστοτόπου, οι Χρήστες μπορούν να απευθύνονται στο <a href="mailto:legal@animap.gr">legal@animap.gr</a>.
        </Paragraph>

        <Divider />

        <Paragraph type="secondary" style={{ textAlign: 'center' }}>
          Δείτε επίσης: <Link to="/privacy">Πολιτική Απορρήτου</Link> | <Link to="/cookies">Πολιτική Cookies</Link>
        </Paragraph>
      </Card>
    </div>
  );
};

export default TermsPage;
